import { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Snackbar, Alert } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { bloquearChat } from '../../actions/chat';
import ReportarChatDialog from './ReportarChatDialog';

// Menú de la conversación abierta (⋮): bloquear / desbloquear a la otra persona y reportar la conversación.
// `zIndex` solo hace falta dentro de la ventana flotante, que está por encima de todo.
const MenuChat = ({ chat, nombre, zIndex, color = 'text.secondary' }) => {
  const dispatch = useDispatch();
  const [ancla, setAncla] = useState(null);
  const [reportando, setReportando] = useState(false);
  const [aviso, setAviso] = useState(null);   // { tipo, texto }
  const bloqueada = Boolean(chat?.bloqueadoPorMi);
  const quien = nombre || 'esta persona';

  const alternarBloqueo = async () => {
    setAncla(null);
    if (!bloqueada && !window.confirm(`¿Bloquear a ${quien}? Mientras dure el bloqueo no podrán escribirse. Puedes quitarlo cuando quieras.`)) return;
    const r = await dispatch(bloquearChat(chat._id, !bloqueada));
    setAviso(r.ok
      ? { tipo: 'success', texto: bloqueada ? 'Persona desbloqueada' : 'Persona bloqueada' }
      : { tipo: 'error', texto: r.error });
  };

  if (!chat?._id) return null;
  const sxZ = zIndex ? { zIndex } : undefined;

  return (
    <>
      <Tooltip title="Más opciones">
        <IconButton aria-label="Más opciones de la conversación" onClick={(e) => setAncla(e.currentTarget)} size="small">
          <MoreVertIcon sx={{ color }} />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={ancla} open={Boolean(ancla)} onClose={() => setAncla(null)} sx={sxZ}>
        <MenuItem onClick={alternarBloqueo}>
          <ListItemIcon>{bloqueada ? <LockOpenOutlinedIcon fontSize="small" /> : <BlockOutlinedIcon fontSize="small" />}</ListItemIcon>
          <ListItemText>{bloqueada ? 'Desbloquear' : 'Bloquear a esta persona'}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { setAncla(null); setReportando(true); }}>
          <ListItemIcon><FlagOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Reportar conversación</ListItemText>
        </MenuItem>
      </Menu>
      <ReportarChatDialog open={reportando} onClose={() => setReportando(false)} chatId={chat._id} nombre={nombre} zIndex={zIndex} />
      <Snackbar
        open={Boolean(aviso)} autoHideDuration={3500} onClose={() => setAviso(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={sxZ}
      >
        {aviso ? <Alert severity={aviso.tipo} onClose={() => setAviso(null)}>{aviso.texto}</Alert> : undefined}
      </Snackbar>
    </>
  );
};

MenuChat.propTypes = {
  chat: PropTypes.object,
  nombre: PropTypes.string,
  zIndex: PropTypes.number,
  color: PropTypes.string,
};

export default MenuChat;
